var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17487 15.7941C12.9113 15.7941 14.9543 12.6979 14.9543 10.0146C14.9543 9.92618 14.9543 9.83771 14.9501 9.75347C15.3461 9.46702 15.6915 9.10897 15.9653 8.70036C15.603 8.86043 15.2113 8.96995 14.7985 9.0205C15.2197 8.76776 15.5398 8.37179 15.6915 7.89579C15.2997 8.12747 14.8659 8.29597 14.4025 8.38864C14.0318 7.99267 13.5052 7.74835 12.9197 7.74835C11.7992 7.74835 10.8893 8.65824 10.8893 9.77874C10.8893 9.93881 10.9062 10.0947 10.9441 10.2421C9.2549 10.1579 7.75949 9.34907 6.75694 8.11905C6.58423 8.41813 6.48313 8.76776 6.48313 9.13845C6.48313 9.84193 6.84119 10.4654 7.3888 10.8276C7.05602 10.8192 6.7443 10.7265 6.47049 10.5749C6.47049 10.5833 6.47049 10.5917 6.47049 10.6002C6.47049 11.5859 7.16975 12.4031 8.1007 12.5926C7.9322 12.639 7.75107 12.6643 7.56572 12.6643C7.43514 12.6643 7.30876 12.6516 7.18239 12.6263C7.43935 13.4351 8.18916 14.0206 9.07798 14.0375C8.38293 14.5809 7.50675 14.9053 6.55474 14.9053C6.39046 14.9053 6.23038 14.8968 6.07031 14.8758C6.95913 15.4571 8.02909 15.7941 9.17487 15.7941Z",
    fill: "#ced3df"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.97168,
    y: 1.45056,
    width: 19.3609,
    height: 19.3609,
    rx: 9.68044,
    stroke: "#ced3df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.87ff9469c1edb7512cb1e4453f85351b.svg";
export { ForwardRef as ReactComponent };